import React from 'react';
import { Users, BookCopy, Star, MapPin } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-white border-b border-gray-100 py-8" data-id="element-240">
      <div className="max-w-5xl mx-auto px-4" data-id="element-241">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 text-center divide-x-0 md:divide-x divide-gray-100" data-id="element-242">
          <div className="flex flex-col items-center justify-center p-2" data-id="element-243">
            <Users className="w-8 h-8 text-blue-600 mb-2" data-id="element-244" />
            <span className="text-3xl font-bold text-gray-900" data-id="element-245">+500</span>
            <span className="text-sm text-gray-500 font-medium mt-1" data-id="element-246">
              profes confían
            </span>
          </div>

          <div className="flex flex-col items-center justify-center p-2" data-id="element-247">
            <BookCopy className="w-8 h-8 text-emerald-600 mb-2" data-id="element-248" />
            <span className="text-3xl font-bold text-gray-900" data-id="element-249">12+6</span>
            <span className="text-sm text-gray-500 font-medium mt-1" data-id="element-250">
              Tomos + Bonus
            </span>
          </div>

          <div className="flex flex-col items-center justify-center p-2" data-id="element-251">
            <Star className="w-8 h-8 text-yellow-400 mb-2 fill-yellow-400" data-id="element-252" />
            <span className="text-3xl font-bold text-gray-900" data-id="element-253">4.9/5</span>
            <span className="text-sm text-gray-500 font-medium mt-1" data-id="element-254">
              calificación
            </span>
          </div>

          <div className="flex flex-col items-center justify-center p-2" data-id="element-255">
            <MapPin className="w-8 h-8 text-red-500 mb-2" data-id="element-256" />
            <span className="text-3xl font-bold text-gray-900" data-id="element-257">🇦🇷</span>
            <span className="text-sm text-gray-500 font-medium mt-1" data-id="element-258">
              Argentina
            </span>
          </div>
        </div>
      </div>
    </section>;
}